import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
@Component({
  selector: 'app-process-complete-dialog',
  templateUrl: './process-complete-dialog.component.html',
  styleUrls: ['./process-complete-dialog.component.scss'],
  standalone: false
})
export class ProcessCompleteDialogComponent {
  title = 'Invoice Process Completed Alert';
  message: any;

  private clickTimeout: any;  // To hold the timeout ID for debounce
  private delay = 300;  // Delay in milliseconds to differentiate single vs double click
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, private router: Router) {
    this.message = data.message;

  }

  navigate() {
    this.router.navigate(["/invoice"]);
  }
}
